// extracted by mini-css-extract-plugin
export default {"wrapper":"QuPd1fXnbgFPWPzZJBdb","phone":"vzAFgCjlCpKdopD3u7OD","home-btn":"aCbVXjO9tAyWUQvsqq5q","screen":"KNK21gW_3cgeFPA8mqlH"};